import {zoomIntegrationActionTypes} from "../../_constants/actions/integrations/zoomIntegrationActiontypes";
import {alertActions} from "../alert.actions";
import {zoomIntegrationService} from "../../_services";
import {history} from "../../_helpers";
import {userActions} from "../user.actions";

export const zoomIntegrationActions = {
    connect,
    disconnect,
    getRecordings,
};

/**
 * Redux Action method that connects to zoom using the given auth code
 * @returns {Function}
 */
function connect(code) {
    return dispatch => {

        // utility constants
        const dispatchRequestStarted = (code) => dispatch({type: zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_REQUEST, code});
        const dispatchRequestSuccess = (code) => dispatch({type: zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_SUCCESS, code});
        const dispatchRequestError = (error) => dispatch({type: zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_FAILURE, error});

        // dispatch that user is being attempted to be integrated
        dispatchRequestStarted(code);

        // call the service
        zoomIntegrationService.connect(code)
            .then(
                () => {
                    dispatchRequestSuccess(code);
                    dispatch(alertActions.success("Zoom-Integration was successfully setup using code " + code));

                    dispatch(userActions.fetchUser());                  // update user information - reflects new integration
                    history.push("/zoom");                              // once successful, strips query code if any
                    dispatch(zoomIntegrationActions.getRecordings({})); // fetch recordings from the new integration
                },
                error => {
                    dispatchRequestError({code: code, ...error});
                    dispatch(alertActions.error(error));

                    history.push("/zoom");                              // unsuccessful, strip code
                    dispatch(zoomIntegrationActions.getRecordings({})); // fetch recordings from old integration, if possible
                }
            );
    };
}

/**
 * Redux Action method that disconnects from zoom
 * @returns {Function}
 */
function disconnect() {
    return dispatch => {

        // utility constants
        const dispatchRequestStarted = () => dispatch({type: zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_REQUEST});
        const dispatchRequestSuccess = () => dispatch({type: zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_SUCCESS});
        const dispatchRequestError = (error) => dispatch({type: zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_FAILURE, error});

        // dispatch that user is being attempted to be disconnected
        dispatchRequestStarted();

        // call the service
        zoomIntegrationService.disconnect()
            .then(
                () => {
                    dispatchRequestSuccess();
                    dispatch(alertActions.success("Zoom-Integration was successfully disconnected"));

                    history.push("/account");      // redirect to home

                    dispatch(userActions.fetchUser());  // update user information - reflects removed integration
                },
                error => {
                    dispatchRequestError({...error});
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * Redux Action method that gets the list of zoom recordings
 * @returns {function(...[*]=)}
 */
function getRecordings(query) {
    return dispatch => {
        // utility constants
        const dispatchRequestStarted = (query) => dispatch({type: zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_REQUEST, query});
        const dispatchRequestSuccess = (response) => dispatch({type: zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_SUCCESS, response});
        const dispatchRequestError = (error) => dispatch({type: zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_FAILURE, error});
        const dispatchReconnectZoom = () => dispatch({type: zoomIntegrationActionTypes.RE_CONNECT_ZOOM_INTEGRATION_INDICATOR});

        // dispatch that user is being attempted to be disconnected
        dispatchRequestStarted(query);

        zoomIntegrationService.getRecordings(query)
            .then(
                response => {
                    dispatchRequestSuccess(response);
                    dispatch(alertActions.success("Zoom-Integration recordings were successfully fetched"));
                },
                error => {
                    dispatchRequestError({...error});
                    dispatch(alertActions.error(error));

                    // if authorization issues, then redirect to connect again
                    if(error.status === 401) {
                        // push to connect-page with reconnect action
                        dispatchReconnectZoom();
                        history.push("/zoom/connect");
                    }
                }
            );
    };
}